import { Modal } from "react-bootstrap";
import { STAGE_STATUS_LOG_HEADERS } from "../actions/Constant";
import DataTable from "../../../../common/DataTable";
import {
  CaseStageHistory,
  fetchStageStatusLogDetails,
} from "../../../../services/CaseInformationApi";
import { useEffect, useState } from "react";
import { dateTimeFormatted } from "../../../../utils/dateUtils";

interface StageStatusLogsProps {
  show: boolean;
  handleClose: () => void;
  caseInfoId: number;
}

const StageStatusLogs: React.FC<StageStatusLogsProps> = ({
  show,
  handleClose,
  caseInfoId,
}) => {
  const [logRows, setLogRows] = useState<CaseStageHistory[]>([]);

  const fetchLogsData = async () => {
    try {
      const listData = await fetchStageStatusLogDetails(caseInfoId);
      const formattedData = (listData || [])?.map((item) => ({
        ...item,
        addedOn: item.addedOn ? dateTimeFormatted(item.addedOn) : "-",
      }));
      setLogRows(formattedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  
  useEffect(() => {
    if (show && caseInfoId) {
      fetchLogsData();
    }
  }, [show, caseInfoId]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="recordList"
    >
      <Modal.Header closeButton className="d-flex">
        <Modal.Title className="fw-bold text-left modelheading offcanvas-title">
          Stage Log
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <DataTable headers={STAGE_STATUS_LOG_HEADERS} rows={logRows} />
      </Modal.Body>
    </Modal>
  );
};

export default StageStatusLogs;
